import './App.scss';
import 'bulma/css/bulma.css'
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom'
import Header from './commonComponents/Header'
import Home from "./AppComponents/Home"
import Game from "./AppComponents/Game"
import NotFound from "./AppComponents/NotFound"
import { useEffect, useState } from 'react';
import ReactGA from 'react-ga';
import { useLanguage } from './Context/LangContext';
import { reactLocalStorage } from 'reactjs-localstorage';
import config, { getHeaders } from "./config"
import Category from './commonComponents/Category';
import Profile from "./AppComponents/Profile";
import Language from './commonComponents/Language';
import Login from "./AppComponents/Login";
import ProtectedRoute from "./ProtectedRoute";
import Loader from './commonComponents/Loader';
import image from "./assets/images/bannerimg.png";
import LandingPage from './AppComponents/LandingPage';
import { hitCallBackApi } from './hook/useHitCallBackApi';
import queryString from "query-string";
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import ThanksPage from './commonComponents/ThanksPage';
import SubscriptionPage from './wap/Subscription';

function App() {
      const { language } = useLanguage();
      const [sideMenu, setSideMenu] = useState(false)
      const [showSideMenu, setshowSideMenu] = useState(true)
      const [loading, setLoading] = useState(true)
      const [banners, setBanners] = useState([])
      const [games, setGames] = useState([])
      let { search, pathname } = useLocation();
      const match1 = useRouteMatch('/game/:id')
      const match2 = useRouteMatch('/login')
      const match3 = useRouteMatch('/lp')
      const { rcid, camp, type } = queryString.parse(search);
      const [appConfigData, setappConfigData] = useState({})
      const history = useHistory();
      const LP_banners = [
            {
                  "img": image,
                  "title": "banner 1"
            }];

      useEffect(() => {
            if (camp) {
                  sessionStorage.setItem('camp', camp)
            }
            if (rcid) {
                  sessionStorage.setItem('rcid', rcid)
            }
            if(type){
                  sessionStorage.setItem('type', type)  
            }
            if (camp && rcid && type) {
                  history.push(`/subscription`)
            }
            getAppConfigData()
      }, []);

      useEffect(() => {
            console.log("Analytics initialize")
            const ga_tag = config.get("ga_tag");
            const ga_debug = config.get("ga_debug");
            console.log("GOOGLE ANALYTICS DEBUG :: ", ga_tag, " :: ", ga_debug);
            ReactGA.initialize(ga_tag, {
                  debug: ga_debug,
                  titleCase: false,
            });
            // to report page view
            history.listen((location) => {
                  ReactGA.set({ page: location.pathname });
                  ReactGA.pageview(location.pathname);
            });
      }, []);

      const getAppConfigData = () => {
            setLoading(true)
            const url = `${config.get('base')}${config.get('appConfig')}`;
            const headers = {
                  ...getHeaders(),
                  Language: language,
                  "cbinfo": localStorage.getItem("cbinfo"),
                  "w_req_url": window.location.href,
                  "camp" : camp,
                  "rcid" : rcid,
                  "type" : type
            }
            fetch(url, {
                  method: 'POST',
                  body: JSON.stringify({ "mcc": "652", "mnc": "04", "uid": reactLocalStorage.get("uid") ? reactLocalStorage.get("uid") : "" }),
                  headers: headers
            })
                  .then(res => {
                        if (!res.ok) { throw res }
                        return res.json()
                  })
                  .then((result) => {
                        console.log('result message appConfig ::', result)
                        const appConfigObj = {
                              menu: result.menu,
                              menu_color: result.menu_color,
                              home_logo: result.home_logo,
                              menu_logo: result.menu_logo,
                              view_all: result.view_all,
                              bg_color: result.bkg_color,
                              play_text: result.play_btn_txt,
                              flow: result.subRedirectFlow,
                              view_btn_txt: result.view_btn_txt,
                              sub_url: result.sub_url,
                              unsub_mode: result.unsubMode,
                              sidemenu: result.sidemenu,
                              unsub_msg_txt: result.unsubData,
                              portrait_txt: result.portrait_txt,
                              rotate_txt: result.rotate_txt,
                              landscape_txt: result.landscape_txt,
                              status_txt: result.status_txt,
                              similar_cat_txt: result.similar_cat_txt,
                              redirect_url: result?.redirect_URL,
                              upstreamUrl: result?.upstream_URL,
                              planText: result?.plantype_text,
                              validity_text: result?.validity_text,
                              loginPage_txt: result?.loginPage
                        }
                        setappConfigData(appConfigObj)

                        setGames(result.games_list)
                        setBanners(result.banner)
                        setLoading(false)
                  },
                        (error) => {
                              console.log('error:::', error)
                        })
      }

      let backgroundClass = '';
      if (match2 ) {
            backgroundClass = '';
      }
       else {
            backgroundClass = 'service-bg';
      }
console.log(":::::::::SUBSCRIPTION URL:::::::::::::", appConfigData?.upstreamUrl)

      if (loading) return <Loader />;
      return (
            <section className={`hero is-fullheight bg ${backgroundClass} ${match3 ? 'subBg' : match2 ? 'loginBg' : ''}`}>
                  {(pathname === '/subscription' || pathname === '/subscription/' || pathname === '/thanks') ? '' :
                        !(match1 || match2 || match3) && <Header loading={loading} menuBar={appConfigData.menu}
                              sub_url={appConfigData.sub_url}
                              sidemenu={appConfigData?.sidemenu}
                              menuLogo={appConfigData.menu_logo} homeLogo={appConfigData.home_logo} handleClick={() => setSideMenu(!sideMenu)} showSideMenu={showSideMenu}
                              setshowSideMenu={() => setshowSideMenu(!showSideMenu)} />}
                  <Switch>
                        <Route path="/login">
                              <Login homeLogo={appConfigData.home_logo}
                                    redirect_url={appConfigData?.redirect_url}
                                    loginPage_txt={appConfigData?.loginPage_txt} />
                        </Route>
                        <ProtectedRoute exact path="/home"
                              component={(routeProps) => (
                                    <Home
                                          {...routeProps} games={games} banners={banners} bgColor={appConfigData.bg_color} view_all={appConfigData.view_all}
                                          setLoading={setLoading}
                                          flow={appConfigData.flow}
                                          loading={loading}
                                          view_btn_txt={appConfigData.view_btn_txt} />
                              )}
                        />
                        <ProtectedRoute exact path="/"
                              component={(routeProps) => (
                                    <Home
                                          {...routeProps} games={games} banners={banners} bgColor={appConfigData.bg_color} view_all={appConfigData.view_all}
                                          setLoading={setLoading}
                                          flow={appConfigData.flow}
                                          loading={loading}
                                          view_btn_txt={appConfigData.view_btn_txt} />
                              )}
                        />
                        <Route exact path="/lp">
                              <LandingPage banners={LP_banners}
                                    subUrl={appConfigData?.upstreamUrl}
                                    homeLogo={appConfigData.home_logo} />
                        </Route>

                        <ProtectedRoute exact path="/game/:title/:id"
                              component={(routeProps) => (
                                    <Game
                                          {...routeProps}
                                          allGames={games}
                                          view_all={appConfigData.view_btn_txt}
                                          portrait_txt={appConfigData.portrait_txt}
                                          rotate_txt={appConfigData.rotate_txt}
                                          landscape_txt={appConfigData.landscape_txt}
                                          similar_cat_txt={appConfigData.similar_cat_txt}
                                    />
                              )} />
                        <ProtectedRoute exact path="/profile"
                              component={(routeProps) => (
                                    <Profile
                                          {...routeProps}
                                          status_txt={appConfigData?.status_txt}
                                          plan_text={appConfigData?.planText}
                                          validity_text={appConfigData?.validity_text}
                                    />
                              )}
                        />
                        <ProtectedRoute exact path="/category"
                              component={(routeProps) => (
                                    <Category
                                          {...routeProps}
                                          play={appConfigData.play_text}
                                    />)}
                        />
                        <ProtectedRoute exact path="/language"
                              component={(routeProps) => (
                                    <Language
                                          {...routeProps}
                                          langObj={appConfigData?.sidemenu?.language}
                                    />
                              )}
                        />
                        <Route path="/subscription">
                              <SubscriptionPage
                                    subUrl={appConfigData?.upstreamUrl}
                                    homeLogo={appConfigData.home_logo}
                              />
                        </Route>
                        <Route path="/thanks">
                              <ThanksPage
                                    homeLogo={appConfigData.home_logo}

                              />
                        </Route>
                        <Route path="*">
                              <NotFound />
                        </Route>
                  </Switch>
            </section>
      );
}
export default App
